import React, { useState } from 'react';
import { ButtonContinue } from '../Button/ButtonContinue';
import './ButtonTabs.scss';
import MediaQuery from 'react-responsive';

export type QuoteButtonTab = {
  buttonText: string;
  buttonClass?: string;
  description: string;
  getQuoteText: string;
  onGetQuoteClick: (callback?: () => void) => void;
  retrieveQuoteText: string;
  onRetrieveQuoteClick: (callback?: () => void) => void;
};

export type QuoteButtonTabsProps = {
  id: string;
  tabs: QuoteButtonTab[];
};

const ButtonTabs = ({ id, tabs }: QuoteButtonTabsProps): JSX.Element => {
  const [showTabIndex, setShowTabIndex] = useState<number>(-1);

  const handleClick = (
    e: React.MouseEvent<HTMLButtonElement>,
    index: number
  ) => {
    e.preventDefault();
    e.stopPropagation();

    if (showTabIndex !== index) {
      setShowTabIndex(index);
    } else {
      setShowTabIndex(-1);
    }
  };

  const tabButton = (
    index: number,
    buttonText: string,
    buttonClass?: string
  ) => {
    let classes = 'button';

    if (showTabIndex !== -1) {
      if (showTabIndex === index) {
        classes = classes.concat(' open-tab');
      } else {
        classes = classes.concat(' closed-tab');
      }
    }

    if (buttonClass) {
      classes = classes.concat(` ${buttonClass}`);
    }

    return (
      <button
        key={`btn-${id}-${index}`}
        id={`btn-${id}-${index}`}
        aria-label={`btn-${id}-${index}`}
        onClick={(e) => {
          handleClick(e, index);
        }}
        className={classes}>
        {buttonText}
      </button>
    );
  };

  const tabSection = (index: number) => {
    if (showTabIndex === index) {
      return (
        <div className='tab-section'>
          <p>{tabs[index].description}</p>
          <div className='flex-row navigation'>
            <ButtonContinue
              name={`btnRetrieveQuote-${id}-${showTabIndex}`}
              text={tabs[index].retrieveQuoteText}
              onClick={tabs[index].onRetrieveQuoteClick}
              additionalClassNames='btn-hero-retrieve'
            />
            <ButtonContinue
              name={`btnGetStarted-${id}-${showTabIndex}`}
              text={tabs[index].getQuoteText}
              onClick={tabs[index].onGetQuoteClick}
              additionalClassNames='btn-hero-start'
            />
          </div>
        </div>
      );
    }

    return <></>;
  };

  return (
    <div id={id} className='button-tabs-widget'>
      <MediaQuery maxWidth={768}>
        {tabs.map((t, index) => {
          return (
            <>
              <div className='tabs'>
                {tabButton(index, t.buttonText, t.buttonClass)}
              </div>
              {tabSection(index)}
            </>
          );
        })}
      </MediaQuery>
      <MediaQuery minWidth={769}>
        <div id={id}>
          <div className='flex-row tabs'>
            {tabs.map((t, index) =>
              tabButton(index, t.buttonText, t.buttonClass)
            )}
          </div>
          {showTabIndex > -1 && tabSection(showTabIndex)}
        </div>
      </MediaQuery>
    </div>
  );
};

export default ButtonTabs;
